export const CONNECTIVITY_STATUS_CHANGED = 'CONNECTIVITY_STATUS_CHANGED';
